import { render, staticRenderFns } from "./ChangeOptionFieldNameRadio.vue?vue&type=template&id=3183b033"
import script from "./ChangeOptionFieldNameRadio.vue?vue&type=script&lang=js"
export * from "./ChangeOptionFieldNameRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports